import React, { FC } from 'react';
import { Element } from 'react-scroll';
import Icon from '@common/assets';
import AddButton from '@components/profile/common/addButton';
import { useUserInfo } from '@repository/auth/useUserInfo';
import useProfileExperience from '@repository/profiles/useProfileExperience';
import ExperienceContents from '@components/profile/userInfoItems/experience/ExperienceContents';
import { ProfileInfo } from '@domain/constant/profile/ProfileOverlayType';

import classnames from 'classnames/bind';
import styles from './experience.module.scss';
const cx = classnames.bind(styles);

interface IExperienceProps {
  onOpenOverlay: () => void;
}

const Experience: FC<IExperienceProps> = ({ onOpenOverlay }) => {
  const { data: userInfo } = useUserInfo();
  const { data: profileExperience } = useProfileExperience(!!userInfo?.id);

  return (
    <Element name={ProfileInfo.EXPERIENCE} className={cx('infoArea')}>
      <div className={cx('sectionTitleArea')}>
        <div className={cx('sectionTitleWrap')}>
          <Icon name="readBookLight" width={40} height={40} />
          경험
          <span className={cx('infoDesc')}>대내외 활동, 해외 경험, 봉사 경험 등을 적어주세요.</span>
        </div>

        {/* 입력 버튼 */}
        <AddButton onClick={onOpenOverlay} />
      </div>

      {profileExperience?.saveYn && <ExperienceContents profileExperience={profileExperience} />}
    </Element>
  );
};

export default Experience;
